import { MFA_ENROLMENT_PATHNAMES } from "@/domain/constants";

/**
 * Normalizes a search param value from expo-router's `useLocalSearchParams`.
 * At runtime the value can be a string, an array (when the param appears
 * multiple times), or undefined. Returns the first element for arrays and
 * falls back to an empty string for undefined.
 */
export const normalizeSearchParam = (
  param: string | string[] | undefined,
): string => {
  if (Array.isArray(param)) return param[0] ?? "";
  return param ?? "";
};

export const checkIsMfaEnrolmentPathname = (pathname: string) =>
  MFA_ENROLMENT_PATHNAMES.includes(pathname);
